import {Component, inject} from '@angular/core';
import {StagingAuthService} from '../../services/staging-auth.service';

@Component({
  selector: 'app-staging-bar',
  template: `
    @if (stagingAuthService.isAuthenticated()) {
      <div class="staging-logout">
        <button (click)="logout()" title="Logout from staging">S</button>
      </div>
    }
  `,
  styles: [
    `
      .staging-logout {
        position: fixed;
        bottom: 5px;
        right: 5px;
        z-index: 999;
      }

      button {
        background-color: rgba(0, 0, 0, 0.2);
        color: rgba(255, 255, 255, 0.8);
        border: none;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      button:hover {
        background-color: rgba(244, 67, 54, 0.8);
        color: white;
      }
    `,
  ],
})
export class StagingBarComponent {
  stagingAuthService = inject(StagingAuthService);

  logout(): void {
    this.stagingAuthService.logout();
  }
}
